export const data1 = [
        {label : 'construit' , color:'#784bc8'},
]
export const data2 = [
        {label : 'zones protégées' , color:'#75d975'},
        {label : 'zones protégées côtières' , color:'#82c8c9'},
        {label : 'zones marines protégées' , color:'#a382c9'},
]
export const data3 = [
        { label: 'Surfaces Artificielles', color: '#000000' },
        { label: 'Agriculture', color: '#ffff4d' },
        { label: 'Forêt à Feuilles Larges', color: '#1a4d00' },
        { label: 'Forêt de Conifères', color: '#007f0e' },
        { label: 'Forêt Mixte', color: '#1aff1a' },
        { label: 'Autres Terres Naturelles', color: '#00ff00' },
        { label: 'Végétation Sclérophylle', color: '#00ff66' },
        { label: 'Végétation de Transition', color: '#00ffcc' },
        { label: 'Autre Couverture Terrestre', color: '#33ffff' },
      ];
export const data4 = [
        { label: 'Terres cultivées et terres cultivées en mosaïque dans les biomes tropicaux et subtropicaux', color: '#ffdd00' },
        { label: 'Forêts à feuilles larges ou mixtes dans les biomes tropicaux et subtropicaux', color: '#009944' },
        { label: 'Forêts de conifères dans les biomes tropicaux et subtropicaux', color: '#007dc3' },
        { label: 'Zones arbustives et prairies dans les biomes tropicaux et subtropicaux', color: '#d400d4' },
        { label: 'Terres cultivées et terres cultivées en mosaïque dans les biomes tempérés', color: '#ffac33' },
        { label: 'Forêts à feuilles larges ou mixtes dans les biomes tempérés', color: '#7bb326' },
        { label: 'Forêts de conifères dans les biomes tempérés', color: '#006db7' },
        { label: 'Zones arbustives et prairies dans les biomes tempérés', color: '#d4e900' },
        { label: 'Forêts à feuilles larges ou mixtes dans les biomes boréaux et de toundra', color: '#2b7900' },
        { label: 'Forêts de conifères dans les biomes boréaux et de toundra', color: '#004999' },
        { label: 'Zones arbustives et prairies dans les biomes boréaux et de toundra', color: '#8c8d00' },
        { label: 'Terres cultivées et terres cultivées en mosaïque dans les biomes méditerranéens et xériques', color: '#f0db4d' },
        { label: 'Forêts à feuilles larges ou mixtes dans les biomes méditerranéens et xériques', color: '#009144' },
        { label: 'Forêts de conifères dans les biomes méditerranéens et xériques', color: '#0073c4' },
        { label: 'Zones arbustives et prairies dans les biomes méditerranéens et xériques', color: '#d7b4ff' },
      ]

